import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetGuaranteeMoneyBalanceHistoryRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getGuaranteeMoneyBalanceHistory = async (
  instance: AxiosInstance,
  params: DefaultApiGetGuaranteeMoneyBalanceHistoryRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getGuaranteeMoneyBalanceHistory(params)
}
